import { useEffect, useState } from "react";

const RegisterView = () => {
  return <div className=""></div>;
};

export default RegisterView;
